import React from 'react';

const About = () => {
  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          <h2 className="mb-6 font-bold text-center">About <span className="text-primary">Us</span></h2>
          <div className="space-y-4 text-lg">
            <p>
              We started by building and growing our own business website over 4+ years. Along the way, we realized we were better at building great sites for others than most expensive agencies — so we turned it into a service.
            </p>
            <p>
              We understand the struggles of small business owners because we've been there. You need a professional online presence, but you don't have time to learn complex website builders or the budget for high-priced agencies.
            </p>
            <p>
              Having worked with many contractors and small businesses, we understand that your website needs to generate leads, not just look pretty.
            </p>
            <p>
              That's why we created Snap Launch Studio — to provide contractors and small businesses with fast, high-quality websites without the hassle, technical jargon, or ongoing fees.
            </p>
            <p>
              We specialize in websites for plumbers, electricians, HVAC contractors, landscapers, roofers, and other local service businesses.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
